import React from "react";
import Styled from "styled-components";
import { SelectionSet, SelectionSetInput, SelectionSetLabel, useId, Typography, SelectionSetTileContents, SelectionSetTilePrice, SelectionSetTileName, } from "@vp/swan";
import { OptionPriceDisplay } from "../../../../shared/options-price-display";
import { ImageTileThumbnail, SelectionSetTileCallouts } from "../";
import { useProductOptionsTranslations, } from "../../../../product-options-translations/product-option-translations";
import { SimpleTitle } from "../../../../shared/simple-title";
import { useProductOptionsFeaturesContext } from "../../../../contexts/product-options-features";
import { buildUnwindingMessageHtml } from "../../../../../helpers/buildUnwindingMessageHtml";
const TightButtons = Styled.div `
.swan-selection-set.swan-selection-set-skin-tiles-horizontal, 
.swan-selection-set.swan-selection-set-skin-tiles-mini,
.swan-selection-set.swan-selection-set-skin-tiles-vertical {
    --grid-gap: var(--swan-sem-space-4);
    gap: var(--grid-gap);
    container-type: inline-size;
    container-name: productOption;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button .swan-selection-set-label {
    margin: 0 !important;
    min-width: unset !important;
    max-width: unset !important;
    width: 100%;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button .swan-selection-set-label {
  height: 100%;
}

.swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
  --grid-columns: 1;
  --column-gaps: 0px;
  flex: 0 1 calc((100% - var(--column-gaps)) / var(--grid-columns));
}

@container productOption (min-width: 260px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
    --grid-columns: 2;
    --column-gaps: var(--grid-gap);
  }
}

@container productOption (min-width: 425px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
    --grid-columns: 3;
    --column-gaps: calc(var(--grid-gap) * 2);
  }
}

@container productOption (min-width: 600px) {
  .swan-selection-set.swan-selection-set-skin-tiles-vertical .tight-button {
    --grid-columns: 4;
    --column-gaps: calc(var(--grid-gap) * 3);
    max-width: 170px
  }
}

.incompatible-option {
  border-width: 2px !important;
  background-color: var(--swan-color-grey-100) !important;
  border-style: dashed;
  border-color:  var(--swan-color-grey-500) !important;
}
`;
export const SnowflakeLayout = ({ children }) => {
    const { disableSwanSnowflakes } = useProductOptionsFeaturesContext();
    if (disableSwanSnowflakes) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(TightButtons, null, children);
};
export const TightButtonSkin = ({ option, locale, currency, fractionDigits, priceDisplayMode = "differential-unit", showIncompatibleChoices, hideImages, tenant, onChanged, }) => {
    const translations = useProductOptionsTranslations();
    /**
     * Converts the 'onChange' of a multi-select listbox to an onChange of a radioGroup
     * @param selectedValues the object of key:boolean pairs of selected options
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onChangeHandler = (selectedValues, event) => {
        if (option.selectedKey) {
            delete selectedValues[option.selectedKey];
        }
        for (const [key, value] of Object.entries(selectedValues)) {
            if (value && key !== option.selectedKey) {
                // Only emit an choiceKey if there's a value picked,
                // otherwise do nothing. A user can't unselect an option
                onChanged({ choiceKey: key });
                break;
            }
        }
    };
    const titleId = useId();
    const selectedValues = {};
    for (const choice of option.choices) {
        selectedValues[choice.key] = choice.key === option.selectedKey;
    }
    return (React.createElement(SnowflakeLayout, null,
        React.createElement(SimpleTitle, { titleId: titleId }),
        React.createElement(SelectionSet, { style: { flexWrap: "wrap" }, variant: "multi-select", skin: "tiles-vertical", selectedValues: selectedValues, onSelectedValuesChange: onChangeHandler, "aria-labelledby": titleId, role: "radiogroup", "aria-required": option.isRequired ? "true" : undefined }, option.choices
            .filter((choice) => showIncompatibleChoices || choice.isCompatible)
            .map((choice) => (React.createElement("div", { className: "tight-button", key: `choice_${choice.key}` },
            React.createElement(SelectionSetInput, { value: choice.key, disabled: !choice.isCompatible && !choice.violations?.length },
                React.createElement(SelectionSetLabel, { className: !choice.violations?.length ? "compatible-option" : "incompatible-option", style: {
                        minHeight: hideImages ? "unset" : "inherit",
                    } },
                    !hideImages && React.createElement(ImageTileThumbnail, { choice: choice }),
                    !hideImages && React.createElement(SelectionSetTileCallouts, { callouts: choice.callouts }),
                    React.createElement(SelectionSetTileContents, null,
                        React.createElement(SelectionSetTileName, null, choice.name),
                        choice.violations?.length ? (React.createElement(Typography, { as: "span", fontWeight: "normal", dangerouslySetInnerHTML: {
                                __html: getUnwindingMessageHtml(choice.violations, translations),
                            } })) : priceDisplayMode === "none" || choice.key === option.selectedKey ? (React.createElement(React.Fragment, null)) : (React.createElement(SelectionSetTilePrice, null,
                            React.createElement(OptionPriceDisplay, { choice: choice, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, fractionDigits: fractionDigits, hideZeroPrice: true, tenant: tenant }))))))))))));
};
function getUnwindingMessageHtml(violations, { i18n }) {
    return buildUnwindingMessageHtml(i18n, "unwindingMessage", violations);
}
//# sourceMappingURL=tight-button-skin.js.map